import React from 'react';

const Filter = () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 1H3L9.4 8.568V13.8L12.6 15.4V8.568L19 1V1Z"
      stroke="#90949C"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default Filter;
